import LogApi from '@/api/common/log';
import PromotionBanner from './PromotionBanner';
import FloatingBanner from './FloatingBanner';

/**
 * 어드민에 등록된 배너 목록을 가져와 노출합니다.
 */
const BottomBanner = ({mainListInfo}) => {
  const {
    mainBannerFloatingResult,
    mainBannerPromotionResult,
    mainBannerFloatingData,
    mainBannerPromotionData,
  } = mainListInfo;
  if (mainBannerFloatingResult !== 1 && mainBannerPromotionResult !== 1) {
    return;
  }
  // 로그
  const sendBannerClickLog =
    (buttonGroup: 'bottom_floating_banner' | 'bottom_promotion_banner') =>
    (buttonType: 'close' | 'do_not_show' | 'landing_page') => {
      LogApi.sendClickLog({
        codeType: 'banner_button',
        sendData: {
          buttonGroup,
          buttonType,
        },
      });
    };

  // 플로팅 배너
  if (mainBannerFloatingResult === 1 && mainBannerFloatingData?.length > 0) {
    return (
      <FloatingBanner
        data={mainBannerFloatingData[0]}
        sendClickLog={sendBannerClickLog('bottom_floating_banner')}
      />
    );
  }

  // 프로모션 배너
  if (mainBannerPromotionResult === 1 && mainBannerPromotionData?.length > 0) {
    return (
      <PromotionBanner
        bannerList={mainListInfo.mainBannerPromotionData}
        sendClickLog={sendBannerClickLog('bottom_promotion_banner')}
      />
    );
  }

  return null;
};

export default BottomBanner;
